// extracted by mini-css-extract-plugin
module.exports = {"container":"HappyHornMessage_container__35IU7"};